import React from "react";
import { useDropzone } from "react-dropzone";
import { Tooltip, useTheme } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import wellknown from "wellknown";
import { StyledMapButton, iconStyle } from './materialTheme/StyledMapComponents';
import "./../../../static/styles/FileUpload.css";

const FileUpload = ({ onFileLoad, setCenter, setZoom }) => {
  const theme = useTheme();

  const handleFileLoad = (geoJson) => {
    onFileLoad(geoJson);
    if (geoJson.features.length > 0) {
      const firstFeature = geoJson.features[0];
      const firstCoordinate = firstFeature.geometry.coordinates[0][0];
      if (Array.isArray(firstCoordinate) && firstCoordinate.length >= 2) {
        setCenter([firstCoordinate[1], firstCoordinate[0]]); // [lat, lng]
        setZoom(8);
      } else {
        alert("Invalid coordinate format:", firstCoordinate);
      }
    } else {
      console.error("Unsupported geometry type:", firstFeature.geometry.type);
    }
  };

  const onDrop = (acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const content = reader.result;
        let geoJson;
        if (file.name.endsWith(".kml")) {
          const kmlGeoJson = wellknown(content);
          geoJson = {
            type: "FeatureCollection",
            features: kmlGeoJson.features,
          };
        } else if (
          file.name.endsWith(".geojson") ||
          file.name.endsWith(".json")
        ) {
          geoJson = JSON.parse(content);
        }
        if (geoJson) {
          handleFileLoad(geoJson);
        }
      };
      reader.readAsText(file);
    });
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <Tooltip title="Upload Geojson">
      <StyledMapButton
        {...getRootProps()}
        variant="contained"
        color="primary"
        className="upload-file-button"
        startIcon={<CloudUploadIcon sx={iconStyle({ theme, isActive: false })} />}
      >
        <input {...getInputProps()} style={{ display: 'none' }} />
      </StyledMapButton>
    </Tooltip>
  );
};

export default FileUpload;